<template>
  <div>
    <div v-if="!disableSearch" class="dt-tools shadow-sm">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            label="Cari"
            dense
            prepend-inner-icon="mdi-magnify"
            :hide-details="true"
            :clearable="true"
            v-model="search"
            background-color="rgba(0, 0, 0, 0.1))"
            :solo="true"
            :flat="true"
            :style="{
              border: '1px solid #d5d5d5'
            }"
          ></v-text-field>
        </v-col>
        <slot name="action" />
      </v-row>
    </div>

    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :loading="loading"
      :options.sync="options"
      items-per-page-text="Baris perhalaman"
      loading-text="Memuat Data"
      no-data-text="Belum ada data"
      no-results-text="Belum ada data"
      class="shadow-sm"
      style="border-radius: 8px"
    >
      <template v-for="slot in slots" v-slot:[slot.name]="{ item }">
        <slot :name="slot.name" v-bind:item="item">{{ item[slot.value] }}</slot>
      </template>

      <template v-if="!disableAction" v-slot:item.actions="{ item }">
        <slot name="item.action" v-bind:item="item"></slot>
        <v-menu right bottom v-if="buttonView">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-if="canView">
              <v-list-item-title>
                <div class="text-center">
                  <v-btn
                    width="30px"
                    rounded
                    depressed
                    color="success"
                    dark
                    @click="onClickView(item)"
                  >
                    VIEW
                  </v-btn>
                </div>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canUpdate">
              <v-list-item-title>
                <div class="text-center">
                  <v-btn
                    width="30px"
                    rounded
                    depressed
                    color="warning"
                    dark
                    @click="onClickUpdate(item)"
                  >
                    EDIT
                  </v-btn>
                </div>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canDelete">
              <v-list-item-title>
                <div class="text-center">
                  <v-btn
                    width="30px"
                    rounded
                    depressed
                    color="error"
                    dark
                    @click.stop.prevent="onClickDelete(item)"
                  >
                    DELETE
                  </v-btn>
                </div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <div v-else-if="viewOnly">
          <v-btn
            width="30px"
            rounded
            depressed
            color="success"
            dark
            @click="onClickView(item)"
          >
            VIEW
          </v-btn>
        </div>

        <div v-else>
          <v-btn
            v-if="canUpdate"
            width="30px"
            rounded
            depressed
            color="warning"
            dark
            @click="onClickUpdate(item)"
          >
            EDIT
          </v-btn>
          {{ "  " }}
          <v-btn
            v-if="canDelete"
            width="30px"
            rounded
            depressed
            color="error"
            dark
            @click.stop.prevent="onClickDelete(item)"
          >
            DELETE
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss">
table tbody tr {
  cursor: pointer !important;
}
.dt-tools {
  padding: 10px;
  margin-bottom: 14px;
  border-radius: 8px;
  background: #ffffff;
}
.dt-pagination {
  padding: 0 14px;
  margin-bottom: 14px;
  border-radius: 8px;
  background: #ffffff;
}
</style>

<script>
import ApiService from "@/core/services/api.service";
import { asset } from "@/core/utils/";
import { forEach, isPlainObject, isArray } from "lodash";
import {
  SET_ACTION,
  ADD_ACTION,
  CLEAR_ACTION
} from "../../core/services/store/actions.module";
import {
  CLEAR_DATE_RANGE,
  SET_DATE_RANGE
} from "../../core/services/store/dateranges.module";

let timeoutSearch;

export default {
  mounted() {
    this.$store.dispatch(CLEAR_ACTION);
    this.$store.dispatch(CLEAR_DATE_RANGE);

    if (!this.disableCreate) {
      if (this.canCreate) {
        this.$store.dispatch(SET_ACTION, [
          {
            text: " Tambah",
            onClick: this.onClickCreate,
            color: "#5685E1",
            icon: "mdi-plus"
          }
        ]);
      }
    }

    if (!this.disableSynchronize) {
      // if (this.canSynchronize) {
      //   this.$store.dispatch(ADD_ACTION, [
      //     {
      //       text: " Synchronize",
      //       onClick: this.onClickSynchronize,
      //       color: "#44bd32",
      //       icon: "mdi-sync"
      //     }
      //   ]);
      // }
    }

    if (!this.disableCreateBulky) {
      if (this.canCreate) {
        this.$store.dispatch(ADD_ACTION, [
          {
            text: " Tambah Banyak",
            onClick: this.onClickCreateBulky,
            color: "#44bd32",
            icon: "mdi-plus",
          }
        ]);
      }
    }

    if (!this.disableDateRange) {
      this.$store.dispatch(SET_DATE_RANGE, [{ text: this.dateRangeText }]);
    }

    if (!this.disableExport) {
      if (this.canExport) {
        this.$store.dispatch(ADD_ACTION, [
          {
            text: " Ekspor",
            onClick: this.onClickExport,
            outlined: true,
            color: "#0062E0",
            icon: "mdi-download"
          }
        ]);
      }
    }

    this.mappingData();
  },
  data() {
    return {
      baseUrl: window.location.origin,
      slots: [],
      search: "",
      loading: true,
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      footerProps: {
        "items-per-page-options": [10, 20, 50, 100],
        "show-current-page": true,
        "items-per-page-text": "Baris perhalaman:",
        pageText: "{0}-{1} dari {2}"
      },
      options: {},
      items: [],
      order: null,
      headers: [],
      dataColumn: []
    };
  },
  props: {
    module: {
      type: String,
      default: null
    },
    url: {
      type: String
    },
    title: {
      type: String
    },
    columns: {
      type: Array
    },
    filter: {
      type: [Array, Object],
      default: null
    },
    actionWidth: {
      type: Number,
      default: 110
    },
    requireFilter: Boolean,
    onClickDelete: {
      type: Function,
      default: function() {}
    },
    onClickCreate: {
      type: Function,
      default: function() {}
    },
    onClickCreateBulky: {
      type: Function,
      default: function() {}
    },
    onClickExport: {
      type: Function,
      default: function() {}
    },
    onClickSynchronize: {
      type: Function,
      default: function() {}
    },
    onClickUpdate: {
      type: Function,
      default: function() {}
    },
    onClickView: {
      type: Function,
      default: function() {}
    },
    onDataUpdate: {
      type: Function,
      default: function() {}
    },
    disableCreate: Boolean,
    disableExport: Boolean,
    disableSynchronize: Boolean,
    disableSearch: Boolean,
    disableAction: Boolean,
    buttonView: Boolean,
    viewOnly: Boolean,
    disableCreateBulky: {
      type: Boolean,
      default: true
    },
    disableDateRange: {
      type: Boolean,
      default: true
    },
    dateRangeText: {
      type: String
    }
  },
  methods: {
    refresh(_callback) {
      let data = this.getData();

      if (_callback) [_callback(data)];
    },
    mappingData() {
      this.dataColumn = this.columns.map(column => {
        const params = {};
        if (column.value) {
          params.data = column.value;
          params.sortable = column.sortable ? true : false;
          params.searchable = column.searchable ? true : false;
        }

        return params;
      });

      this.headers = [];
      this.columns.map(column => {
        if (!column.text) {
          return;
        }
        this.slots.push({
          name: "item." + column.value,
          value: column.value
        });

        let headerColumn = { ...column };
        delete headerColumn.searchable;
        this.headers.push(headerColumn);
      });
      if (!this.disableAction) {
        this.headers.push({
          text: "Tindakan",
          value: "actions",
          align: "center",
          sortable: false,
          width: this.actionWidth
        });
      }
    },
    async getData() {
      if (!this.url) {
        return;
      }
      if (this.requireFilter && !this.filter) {
        return;
      }
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const params = {
        columns: this.dataColumn,
        page: page,
        perPage: itemsPerPage
      };

      if (sortBy.length === 1 && sortDesc.length === 1) {
        params.order = {
          column: sortBy[0],
          dir: sortDesc[0] ? "asc" : "desc"
        };
      }

      if (this.search !== "") {
        params.search = {
          value: this.search
        };
      }

      if (this.filter) {
        params.filter = [];

        if (isPlainObject(this.filter)) {
          params.filter.push({
            column: this.filter.column,
            value: this.filter.value,
            operator: this.filter.operator || "eq"
          });
        } else if (isArray(this.filter)) {
          forEach(this.filter, vfilter => {
            params.filter.push({
              column: vfilter.column,
              value: vfilter.value,
              operator: vfilter.operator || "eq"
            });
          });
        }
      }

      const dataModule = await ApiService.post(this.url, params);
      this.loading = false;
      this.items = dataModule.data.data;
      this.totalItems = dataModule.data.recordsTotal;

      return dataModule.data;
    },
    asset
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    filter() {
      this.refresh();
    },
    search() {
      if (this.disableSearch) return;
      clearTimeout(timeoutSearch);
      timeoutSearch = setTimeout(() => {
        this.options.page = 1;
        this.getData();
      }, 500);
    },
    columns() {
      this.mappingData();
    },
    totalItems() {
      if (this.onDataUpdate) {
        this.onDataUpdate({
          items: this.items,
          totalItems: this.totalItems
        });
      }
    }
  },
  computed: {
    canView() {
      if (this.module == null) {
        return true;
      } else if (this.$store.getters.hasPermission(this.module, "view")) {
        return true;
      }

      return false;
    },
    canCreate() {
      if (this.module == null) {
        return true;
      } else if (this.$store.getters.hasPermission(this.module, "create")) {
        return true;
      }

      return false;
    },
    canUpdate() {
      if (this.module == null) {
        return true;
      } else if (this.$store.getters.hasPermission(this.module, "update")) {
        return true;
      }

      return false;
    },
    canDelete() {
      if (this.module == null) {
        return true;
      } else if (this.$store.getters.hasPermission(this.module, "delete")) {
        return true;
      }

      return false;
    },
    canSynchronize() {
      if (this.module == null) {
        return true;
      } else if (
        this.$store.getters.hasPermission(this.module, "synchronize")
      ) {
        return true;
      }

      return false;
    },
    canExport() {
      if (this.module == null) {
        return true;
      } else if (this.$store.getters.hasPermission(this.module, "export")) {
        return true;
      }

      return false;
    }
  }
};
</script>

<style lang="scss">
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #fcfcfc !important;
  .btn-icon {
    background: #fff;
  }
}
</style>
